import {defineStore} from 'pinia'
import {ref, computed} from 'vue'

export const useCurrencyStore = defineStore('currency', () => {
    const rawCurrency = ref(useRuntimeConfig().public.currency ?? 'SEK')
    const rawRate = ref(1)

    const currency = computed({
        get: () => rawCurrency.value,
        set: (val) => (rawCurrency.value = val)
    })

    const rate = computed({
        get: () => rawRate.value,
        set: (val) => (rawRate.value = val)
    })

    return {currency, rate}
})
